/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_ButtonInputs */

const en_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const fr_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter`)
};

const de_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const it_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportare`)
};

const ru_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт`)
};

const es_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

const zh_cn2_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出口`)
};

const ja_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸出`)
};

const hi_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात`)
};

const pt_pt2_manual_qc_export_button = /** @type {(inputs: Manual_Qc_Export_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Manual_Qc_Export_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_button = /** @type {((inputs?: Manual_Qc_Export_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_export_button(inputs)
	if (locale === "de") return de_manual_qc_export_button(inputs)
	if (locale === "it") return it_manual_qc_export_button(inputs)
	if (locale === "ru") return ru_manual_qc_export_button(inputs)
	if (locale === "es") return es_manual_qc_export_button(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_export_button(inputs)
	if (locale === "ja") return ja_manual_qc_export_button(inputs)
	if (locale === "hi") return hi_manual_qc_export_button(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_export_button(inputs)
	return en_manual_qc_export_button(inputs)
});